export default "__VITE_ASSET__DIWyHUnw__"